// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .address-dropDown {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-bottom: ${(props) =>
        props?.isLoginV2FlowEnabled
          ? props.theme.spacing.ELEM_SPACING.MED
          : props.theme.spacing.ELEM_SPACING.XL};
    }
    .address {
      font-family: ${(props) => props.theme.typography.fonts.secondary};
      color: ${(props) => props.theme.colors.PRIMARY.DARK};
    }
    .address-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    .default-badge {
      height: 13px;
      z-index: 1;
    }
    .dropdown-title {
      font-size: ${(props) => props.theme.typography.fontSizes.fs10};
      font-weight: ${(props) => props.theme.typography.fontWeights.extrabold};
    }
    .customSelectTitle {
      margin-top: 0px;
      padding-top: 4px;
    }
  }

  li.dropdownActiveClass:nth-last-of-type(1) {
    background-color: ${(props) => props.theme.colorPalette.white};
    position: inherit;
  }

  .dropdownActiveIcon {
    display: none;
  }

  .customSelectArrow {
    right: 0;
  }

  .add-address {
    cursor: pointer;
  }

  .default-shipping {
    margin-bottom: 0;
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding-bottom: ${(props) => (!props.isEditing ? props.theme.spacing.ELEM_SPACING.XL : 0)};
      border-bottom: ${(props) =>
        !props.isEditing ? `1px solid ${props.theme.colorPalette.gray[500]}` : 'none'};
    }
  }

  .save-btn {
    background-color: ${(props) => props.theme.colorPalette.blue.C900};
    color: ${(props) => props.theme.colors.WHITE};
    padding: 0;
    &:hover {
      background: ${(props) => props.theme.colorPalette.blue.C900};
    }
  }

  .cancel-btn {
    min-height: 51px;
    padding: 0;
  }

  .edit-cta {
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
    border-bottom: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
    margin-top: ${(props) =>
      props.editShipmentDetailsError ? 0 : props.theme.spacing.ELEM_SPACING.XL};
    .save-btn {
      min-height: 51px;
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      }
    }
  }

  .hide-on-mobile {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: none;
    }
  }

  .top-border {
    padding-top: ${(props) => props.theme.spacing.MED};
    border-top: 1px solid ${(props) => props.theme.colorPalette.gray[300]};
  }

  input {
    background-color: ${(props) => (props.modalState ? props.theme.colorPalette.white : '')};
  }

  .Modal_Heading {
    font-weight: ${(props) => props.theme.typography.fontWeights.extrabold};
  }
  .edit-shipping-error {
    span {
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
      font-weight: ${(props) => props.theme.typography.fontWeights.extrabold};
    }
  }
  .edit-shipping-error-container {
    display: flex;
  }
  .edit-link-placement {
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: flex;
      align-items: center;
    }
  }
  .select__input {
    font-size: ${(props) => props.theme.typography.fontSizes.fs13};
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  }

  .CheckBox__input {
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }

  .shipping-section-header {
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: auto;
      margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    }
  }

  .save-cancel-btn {
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      max-width: 162px;
    }
  }

  .reg-shipping-edit-btn {
    float: right;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) => props.theme.fonts.fontSize.button.size}px;
    line-height: 1.71;
    letter-spacing: 0.2px;
    color: ${(props) => props.theme.colors.BUTTON.BLACK.NORMAL};
    text-decoration: underline;
    border: 0;
    text-transform: capitalize;
    padding-right: 0;
  }

  .reg-shipping-header-container {
    margin-right: 0;
  }

  .reg-shipping-parent-cta {
    position: relative;
    top: 25%;
    text-align: right;
  }

  .reg-shipping-header {
    display: inline-flex;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    color: ${(props) => props.theme.colors.BUTTON.BLACK.NORMAL};
    font-size: ${(props) => `${props.theme.fonts.fontSize.body.bodytext.copy4}px`};
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
  }

  .address-list-container .slick-prev {
    left: 0px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      box-shadow: -18px 0px 36px 20px ${(props) => props.theme.colorPalette.white};
    }
  }

  .address-list-container .slick-next {
    right: 0px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      box-shadow: -18px 0px 36px 20px ${(props) => props.theme.colorPalette.white};
    }
  }
  .checkBoxLabelAlign {
    align-items: center;
    .CheckBox__input {
      width: 18px;
      height: 18px;
      &::before {
        border-radius: 4px;
      }
      &::after {
        left: 7px;
        top: 3px;
      }
    }
  }
`;

export default styles;
